import { ScrollNotify, registerScroll, removeScroll } from './scroll' 
import Bezier from './bezier' 

export default class ScrollAnimate extends ScrollNotify { 
    run() { 
        var self = this; 
        var fn = this.fn = ()=> { 
            if(self.currentTop == self.baseDom.getScrollTop()) return; 

            if(self.currentTop > self.baseDom.getScrollTop()) { 
                self.scrollUp(); 
            }else { 
                self.scrollDown(); 
            } 
        };

        registerScroll(fn); 
    } 
    stop() { 
        removeScroll(this.fn); 
        this.stopAnimate = true; 
    } 
    constructor(config) { 
        super(config); 
    } 
    scrollDown() { 
        var time = 1000; 

        var scrollHeight = window.innerHeight; 

        var from = this.currentTop; 

        var to = from + scrollHeight; 

        if(to > document.documentElement.offsetHeight) 
            to = document.documentElement.offsetHeight; 
        
        if(from == to) return; 

        this.animate({ from, to, time }); 
    } 
    scrollUp() { 
        var time = 1000; 

        var scrollHeight = window.innerHeight; 

        var from = this.currentTop; 

        var to = from - scrollHeight; 

        if(to < 0) to = 0; 

        if(from == to) return; 

        this.animate({ from, to, time }); 
    } 
    animate(config) { 

        if(this.bezier) return; 

        var self = this; 

        var bezier = this.bezier = new Bezier({ 
            from : config.from, 
            to: config.to, 
            time: config.time, 
            outFn(distance) { 
                if(self.stopAnimate) return; 

                self.setScrollTop(distance); 

                self.onscroll(); 
            },
            onend() { 
                self.bezier = null; 
            } 
        }); 
        bezier.runWithCalc(); 
    }
    setScrollTop(pos) { 
        document.body.scrollTop = pos; 
        document.documentElement.scrollTop = pos; 
    } 
} 



// WEBPACK FOOTER //
// ./src/api/scrollAnimate.js


// WEBPACK FOOTER //
// ./src/api/scrollAnimate.js